import React, { createContext, useState } from "react";

export const ToastContext = createContext();

export const useToast = () => {
  const [message, setMessage] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [type, setType] = useState("success");
  const [duration, setDuration] = useState(1500); // Default duration is 5 seconds
  const [onClose, setOnClose] = useState(null); // Callback function to be called when the toast is closed

  const showToast = (
    msg,
    msgType = "success",
    durationMs = 1500,
    onCloseCallback = null
  ) => {
    setMessage(msg);
    setType(msgType);
    setDuration(durationMs);
    setOnClose(() => onCloseCallback);
    setIsVisible(true);
    setTimeout(() => setIsVisible(false), durationMs);
  };

  const closeToast = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  return { message, isVisible, showToast, closeToast, type, duration, onClose };
};

export const ToastProvider = ({ children }) => {
  const toast = useToast();
  return (
    <ToastContext.Provider value={toast}>{children}</ToastContext.Provider>
  );
};
